/* eslint-disable @typescript-eslint/no-unnecessary-condition */

export function getStorage() {
  if (typeof window === "undefined") {
    throw new Error("Cannot run outside of browser");
  }
  const storage = window.localStorage || window.sessionStorage;
  if (!storage) throw new Error("LocalStorage not avaialable");

  return storage;
}

export function storageFetch(key: string, getDefault: () => string): string {
  const storage = getStorage();
  const value = storage.getItem(key);
  if (value != null) return value;
  const defaultValue = getDefault();
  storage.setItem(key, defaultValue);
  return defaultValue;
}
